export default function(type = "", action) {
    if(action.type === "addType") {
        var newType = action.whatType;
        return newType
    }else {
        return type
    }
}